import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { PipeModule } from '@app/system/pipes/pipe.module';

@NgModule({
	declarations: [AlertComponent],
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		FlexLayoutModule,
		MatTooltipModule,
		PipeModule
	],
	exports: [AlertComponent]
})
export class AlertModule { }
